module.exports = __webpack_public_path__ + "img/component.450d2864.svg";